/**
 * Defensive filter for Report History dropdown rows.
 * Trusts scoped API responses — only rejects explicit wrong-user rows.
 */

export const filterReportHistoryRows = (rows, effectiveUserId) => {
  if (!Array.isArray(rows)) return [];

  const seenReportIds = new Set();

  return rows.filter((row) => {
    if (!row?.report_id) return false;
    if (seenReportIds.has(row.report_id)) return false;
    if (effectiveUserId && row.user_id && row.user_id !== effectiveUserId) return false;
    seenReportIds.add(row.report_id);
    return true;
  });
};
